import type * as ecModels from '../../../models'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State<
  TTypeParams extends
    ecModels.TypeParams.Constraint = ecModels.TypeParams.Constraint,
> {
  attributes: readonly ecModels.Attribute<TTypeParams>[] | undefined
  isLoading: boolean
  error?: Error
}
export namespace State {
  export const INITIAL: State<any> = {
    attributes: undefined,
    isLoading: false,
  }
}
